import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { formValueSelector } from 'redux-form';

import { LOG_IN_FORM } from '../../constants';

import {
    clearAuthNotification as clearAuthNotificationAction,
    redirectToLogIn as redirectToLogInAction,
    trackSocialProviderCreateAccount as trackSocialProviderClickAction,
    signUpUser as signUpUserAction,
    trackEmailMismatchAction,
    trackEmailConfirmationInput as trackEmailConfirmationAction,
} from '../../actions/auth';

import {
    lookupUser as lookupUserAction,
    setSignupSecondStep as setSignupSecondStepAction,
} from '../../actions/lookup';

import {
    socialLogInUser as socialLogInUserAction,
    socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction,
    socialLogInUserAuthorized as socialLogInUserAuthorizedAction,
} from '../../actions/social';

import SignupPage from './SignupPage';

const _mapStateToProps = (state) => ({
    form: state.form,
    email: state.authentication.email,
    locale: state.authentication.locale,
    recaptcha2PublicKey: state.authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: state.authentication.recaptcha3PublicKey,
    showCaptcha: state.authentication.displayCaptcha,
    fp: state.authentication.fp,
    socialSSOSettings: state.authentication.socialSSOSettings,
    authNotificationOptions: state.authentication.authNotificationOptions,
    disableRecaptcha3: state.authentication.disableRecaptcha3,
    usesNewStyles:
        state.authentication.featureFlags.launchAuthenticationRefactor,
    signUpSecondStep: state.status.signUpSecondStep,
    previousFormEmail: formValueSelector(LOG_IN_FORM)(state, 'email'),
});

const _mapDispatchToProps = {
    clearAuthNotification: clearAuthNotificationAction,
    onLoginInsteadClick: redirectToLogInAction,
    onSocialProviderClick: trackSocialProviderClickAction,
    onSocialLogInUser: socialLogInUserAction,
    onSocialLogInUserNotAuthorized: socialLogInUserNotAuthorizedAction,
    onSocialLogInUserAuthorized: socialLogInUserAuthorizedAction,
    onSignupLookup: lookupUserAction,
    onSignUpUser: signUpUserAction,
    clearAuthNotification: clearAuthNotificationAction,
    trackEmailConfirmationEdit: trackEmailConfirmationAction,
    trackEmailMismatchShowed: trackEmailMismatchAction,
    setSignupSecondStep: setSignupSecondStepAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SignupPage),
);
